
import Vue from "vue";
import AppMissingModule from "@/components/common/MissingModule.vue";

export default Vue.extend({
	props: {
		link: String,
	},
	computed: {
		input():HTMLInputElement {
			return (this.$refs.input as any).inputElement as HTMLInputElement;
		}
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		copyLink() {
			this.input.select();
			document.execCommand("copy");
			this.$wf.notify(this.$ct("coppied"), "success", 3000, "check");
		},
		openLink() {
			window.open(this.link, "_blank");
		},
		isAllowed(): Boolean {
			return true;
			//return AuthService.hasModule(83);
		}
	},
	components: {
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.PublicLink"
	}
});
